module.exports = __webpack_public_path__ + "img/hr-express-underground-belt-structure.05c53cd9.png";